import ListItemModel from '@/dex-shared/models/ListItemModel';

export default class AdminListItemModel extends ListItemModel {
  constructor(list: any, getters: any) {
    super(list, getters);
  }

  static get __typename(): string {
    return ListItemModel.__typename;
  }

  get viewLink(): string {
    if (this.questionId) {
      return `/questao/${this.questionId}`;
    }
    if (this.articleId) {
      return `/explicacao/${this.articleId}`;
    }
    return `/`;
  }

  get editLink(): string {
    if (this.questionId) {
      return `/editar_questao/${this.questionId}`;
    }
    if (this.articleId) {
      return `/editar_explicacao/${this.articleId}`;
    }
    if (this.videoId) {
      return `/editar_video/${this.videoId}`;
    }
    return `/`;
  }
}
